import React, { Component } from "react";
import PropTypes from "prop-types";
import { Route } from "react-router";
import { Table } from "antd";
import { FormattedMessage, injectIntl } from "react-intl";
import { LEAD_CUSTOMER_JOURNEY } from "./gql/query";
import { graphql } from "react-apollo";
import moment from "moment";

import { Loading } from "../../utils/loading";
import { linesToParagraphs } from "../../landing/common/Functions";
// CustomerJourney component; render table with lead's journey
class CustomerJourney extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired
  };

  _rowClassName = ({ thisLead }, index) =>
    (thisLead && "fraud_highlight ") + (index % 2 === 0 ? "odd" : "even");

  _renderURL = (text, maxWidth = '85px') => (
    <div title={text} style={{maxWidth}}>
      {text ? (
        <a
          target="_blank"
          title={text}
          href={text}
          onClick={e => e.stopPropagation()}
          style={{
            maxWidth: "105px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block"
          }}
        >
          {text.replace(/http\:\/\/(www.)?/, "")}
        </a>
      ) : (
        <FormattedMessage id="analytics.unknown" defaultMessage="Unknown" />
      )}
    </div>
  );

  render() {
    const { loading, data } = this.props.data;
    const { formatMessage } = this.props.intl;
    const sourceData =
      data && data.data.map((row, id) => ({ ...row, id: id + 1 }));
    const unknownMsg = formatMessage({
      id: "analytics.unknown",
      defaultMessage: "Unknown"
    });

    const columns = [
      {
        title: "#",
        dataIndex: "id",
        key: "id",
        render: text => {
          return (
            <div title={text} style={{ maxWidth: "55px" }}>
              {text}
            </div>
          );
        }
      },
      {
        title: <FormattedMessage id="analytics.date" defaultMessage="Date" />,
        dataIndex: "submitTime",
        key: "submitDate",
        render: text => {
          return (
            <div title={text} style={{ maxWidth: "65px" }}>
              {text
                ? moment.utc(text).format(
                    formatMessage({
                      id: "analytics.date-format",
                      defaultMessage: "YY.MM.DD"
                    })
                  )
                : unknownMsg}
            </div>
          );
        }
      },
      {
        title: <FormattedMessage id="analytics.time" defaultMessage="Time" />,
        dataIndex: "submitTime",
        key: "submitTime",
        render: text => {
          return (
            <div title={text} style={{ maxWidth: "65px" }}>
              {text ? moment.utc(text).format("HH:mm") : unknownMsg}
            </div>
          );
        }
      },
      {
        title: (
          <div>
            <FormattedMessage
              id="analytics.thead-affiliateNetwork"
              defaultMessage="Affiliate network"
            >
              {linesToParagraphs}
            </FormattedMessage>
          </div>
        ),
        dataIndex: "affiliateNetwork.nameEng",
        key: "affiliateNetwork.nameEng",
        render: text => {
          return (
            <div title={text} style={{ maxWidth: "75px" }}>
              {text || unknownMsg}
            </div>
          );
        }
      },
      {
        title: <FormattedMessage id="analytics.buyer" defaultMessage="Buyer" />,
        dataIndex: "buyer",
        key: "buyer",
        render: text => {
          return (
            <div title={text} style={{ maxWidth: "75px" }}>
              {text}
            </div>
          );
        }
      },
      {
        title: (
          <FormattedMessage id="analytics.product" defaultMessage="Product" />
        ),
        dataIndex: "product",
        key: "product",
        render: text => {
          return (
            <div title={text} style={{ maxWidth: "105px" }}>
              {text || unknownMsg}
            </div>
          );
        }
      },
      {
        title: (
          <div>
            <FormattedMessage
              id="analytics.deviceType"
              defaultMessage="Device type"
            >
              {linesToParagraphs}
            </FormattedMessage>
          </div>
        ),
        dataIndex: "deviceType",
        key: "deviceType",
        render: text => {
          return (
            <div title={text} style={{ maxWidth: "105px" }}>
              {text || unknownMsg}
            </div>
          );
        }
      },
      {
        title: (
          <FormattedMessage id="analytics.referrer" defaultMessage="Referrer" />
        ),
        dataIndex: "referrer",
        key: "referrer",
        render: text => this._renderURL(text, '65px')
      },
      {
        title: "URL",
        dataIndex: "url",
        key: "url",
        render: text => this._renderURL(text)
      },
      {
        title: (
          <div>
            <FormattedMessage
              id="analytics.isNameMatched"
              defaultMessage="Name matched"
            >
              {linesToParagraphs}
            </FormattedMessage>
          </div>
        ),
        dataIndex: "isNameMatched",
        key: "isNameMatched",
        render: text => {
          return (
            <div title={text ? "+" : "-"} style={{ maxWidth: "105px" }}>
              {text ? "+" : "-"}
            </div>
          );
        }
      },
      {
        title: (
          <div>
            <FormattedMessage
              id="analytics.isPhoneMatched"
              defaultMessage="Phone matched"
            >
              {linesToParagraphs}
            </FormattedMessage>
          </div>
        ),
        dataIndex: "isPhoneMatched",
        key: "isPhoneMatched",
        render: text => {
          return (
            <div title={text ? "+" : "-"} style={{ maxWidth: "105px" }}>
              {text ? "+" : "-"}
            </div>
          );
        }
      },
      {
        title: (
          <div>
            <FormattedMessage
              id="analytics.isEmailMatched"
              defaultMessage="Email matched"
            >
              {linesToParagraphs}
            </FormattedMessage>
          </div>
        ),
        dataIndex: "isEmailMatched",
        key: "isEmailMatched",
        render: text => {
          return (
            <div title={text ? "+" : "-"} style={{ maxWidth: "105px" }}>
              {text ? "+" : "-"}
            </div>
          );
        }
      },
      {
        title: (
          <div>
            <FormattedMessage
              id="analytics.ipMatched"
              defaultMessage="Ip matched"
            >
              {linesToParagraphs}
            </FormattedMessage>
          </div>
        ),
        dataIndex: "ipMatched",
        key: "ipMatched",
        render: text => {
          return (
            <div title={text ? "+" : "-"} style={{ maxWidth: "105px" }}>
              {text ? "+" : "-"}
            </div>
          );
        }
      }
    ];

    return loading ? (
      <Loading />
    ) : (
      <div>
        <h2>
          <FormattedMessage
            id="analytics.lead.header.CJ"
            defaultMessage="Customer journey"
          />
        </h2>
        {sourceData.length ? (
          <Route
            render={({ history }) => (
              <Table
                className="cj-table"
                rowClassName={this._rowClassName}
                rowKey="id"
                columns={columns}
                dataSource={sourceData}
                pagination={false}
                onRow={({ leadId }) => ({
                  onClick: () => {
                    // Open the lead-information in new tab with fallback to native redirect
                    if (leadId && !window.open(`lead?id=${leadId}`))
                      history.push(`/dashboard/analytics/lead?id=${leadId}`);
                  }
                })}
              />
            )}
          />
        ) : (
          <p style={{ textAlign: "center" }}>
            <FormattedMessage id="analytics.nodata" defaultMessage="No data" />
          </p>
        )}
      </div>
    );
  }
}

export default graphql(LEAD_CUSTOMER_JOURNEY, {
  options: ({ id }) => ({
    variables: { id }
  })
})(injectIntl(CustomerJourney));



// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/CustomerJourney.js